
import React from 'react';
import { Pulse } from './Animations';

/**
 * Reusable StatMeter component for visualizing numeric metrics (1-5 or 1-10)
 * Styled with subtle fantasy RPG influence - glowing XP bar aesthetic
 */
const StatMeter = ({ label, value, scale = 10, colorClass = "bg-wine-500", showValue = true }) => {
    const numValue = Number(value);
    const percentage = Math.min(100, Math.max(0, (numValue / scale) * 100));

    // Determine intensity tier for glow effect
    const tier = percentage > 80 ? 'high' : percentage > 50 ? 'mid' : 'low';
    const glowIntensity = {
        high: 'shadow-[0_0_12px_rgba(231,111,129,0.5)]',
        mid: 'shadow-[0_0_8px_rgba(231,111,129,0.3)]',
        low: 'shadow-[0_0_4px_rgba(231,111,129,0.2)]'
    };

    return (
        <div className="space-y-1.5" role="meter" aria-label={label} aria-valuenow={numValue} aria-valuemin="0" aria-valuemax={scale}>
            <div className="flex justify-between items-center text-sm font-medium" aria-hidden="true">
                <span className="text-gray-300">{label}</span>
                {showValue && (
                    <span className={`font-bold ${tier === 'high' ? 'text-wine-400' : 'text-white'}`}>
                        {numValue}/{scale}
                    </span>
                )}
            </div>
            <div className="h-2.5 bg-dark-800 rounded-full overflow-hidden border border-dark-700 relative" aria-hidden="true">
                <div
                    className={`h-full rounded-full transition-all duration-700 ease-out ${colorClass} ${glowIntensity[tier]}`}
                    style={{ width: `${percentage}%` }}
                />
                {/* Subtle shimmer overlay for high values */}
                {tier === 'high' && (
                    <Pulse
                        className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent"
                        style={{ opacity: 0.3 }}
                    />
                )}
            </div>
        </div>
    );
};

export default StatMeter;

